import { render, staticRenderFns } from "./CoreBusinessView.vue?vue&type=template&id=2f59dea6&scoped=true"
import script from "./CoreBusinessView.vue?vue&type=script&lang=js"
export * from "./CoreBusinessView.vue?vue&type=script&lang=js"
import style0 from "./CoreBusinessView.vue?vue&type=style&index=0&id=2f59dea6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f59dea6",
  null
  
)

export default component.exports